'use client'

import { useEffect } from 'react'
import { openCheckout } from '@/lib/paddle/checkout'
import { RADAR_PACK_OPTIONS } from '@/lib/radar/pricing-tiers'

/**
 * Connects the reference /platform pricing controls to the live checkout:
 * pack buttons show the real Paddle pack prices, "Choose audit pack" opens
 * the selected pack and "Start Pro" opens the retainer, the same calls the
 * previous page made. Listens on the document so it runs after the
 * reference script's own pack handler and its price text wins.
 */
export default function PlatformBridge() {
  useEffect(() => {
    const byCount = new Map(RADAR_PACK_OPTIONS.map(o => [o.count, o]))
    const selected = () =>
      byCount.get(
        Number(
          document
            .querySelector('#packs [aria-pressed="true"]')
            ?.getAttribute('data-n') ?? 1
        )
      ) ?? RADAR_PACK_OPTIONS[0]
    const showPrice = () => {
      const el = document.getElementById('packPrice')
      if (el) el.textContent = selected().price
    }
    const onClick = (e: MouseEvent) => {
      const t = e.target as Element | null
      if (!t) return
      if (t.closest('#packs button')) showPrice()
      if (t.closest('#packCta')) {
        e.preventDefault()
        void openCheckout(selected().product, 'pricing_page')
      }
      if (t.closest('a[href="/platform#pro"]')) {
        e.preventDefault()
        void openCheckout('retainer', 'pricing_page')
      }
    }
    showPrice()
    document.addEventListener('click', onClick)
    return () => document.removeEventListener('click', onClick)
  }, [])
  return null
}
